export default __webpack_public_path__ + "static/media/consorcio-color.db33ed06.svg";